export { default } from "./ClickTooltip";
